import { Routes, Route } from 'react-router-dom';
import CustomerList from './pages/CustomerList';
import CustomerForm from './pages/CustomerForm';
import CustomerDetails from './pages/CustomerDetails';

function CustomerRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CustomerList />} />
      <Route path="addCustomer" element={<CustomerForm />} />
      <Route path="edit/:id" element={<CustomerForm />} />
      <Route path=":id" element={<CustomerDetails />} /> {/* Keep this last */}
    </Routes>
  );
}


export default CustomerRoutes;
